export default "__VITE_ASSET__Q0rqIIH5__"